import { render } from "./Header.vue?vue&type=template&id=61dd7a3d&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=61dd7a3d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61dd7a3d"
/* hot reload */
if (module.hot) {
  script.__hmrId = "61dd7a3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61dd7a3d', script)) {
    api.reload('61dd7a3d', script)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=61dd7a3d&scoped=true", () => {
    api.rerender('61dd7a3d', render)
  })

}

script.__file = "src/components/Header.vue"

export default script